import type { BlockHighlightRealEstate as BlockHighlightRealEstateType } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'
import { SingleHighlightEntry } from '../components/SingleHighlightEntry'
import { HighlightBlockAsCards } from './HighlightBlockAsCards'
import { HighlightReel } from './HighlightReel'

//Keys must match contentful variant
const VariantMapping: Record<
  string,
  FunctionComponent<
    React.PropsWithChildren<{ block: BlockHighlightRealEstateType }>
  >
> = {
  HighlightReel: HighlightReel,
  CardsInRows: HighlightBlockAsCards,
  SingleEntry: SingleHighlightEntry,
}

export const BlockHighlightRealEstate: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockHighlightRealEstateType
  }>
> = ({ block }) => {
  const variant = block.variant
  if (!variant) return null
  const Component = VariantMapping[variant]
  return <Component block={block} />
}
